import ApiService from "../api";

export default class FeriadoService extends ApiService {

    constructor() {
        super("/api/feriados");
    }

    listar(ano) {
        return this.get(`?ano=${ano}`);
    }

    cadastrar({ data, descricao }) {
        return this.post("", { data, descricao });
    }

    remover(id) {
        return this.delete(`/${id}`);
    }
}
